import { useEffect, useState } from 'react';

function useLocationValue({ value, type }) {
  const [locationValue, setLocationValue] = useState<any>(value);
  const [isPermissionDenied, setIsPermissionDenied] = useState(false);

  useEffect(() => {
    if (type === 'check_in') {
      setIsPermissionDenied(false);

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocationValue({
            latitude: Number(latitude.toFixed(5)),
            longitude: Number(longitude.toFixed(5)),
          });
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            setIsPermissionDenied(true);
          }
          setLocationValue(null);
        },
      );
    } else {
      setLocationValue(value);
    }
  }, [value, type]);

  return { locationValue, isPermissionDenied };
}

export default useLocationValue;
